import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 20 20"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M3 6.574a.7.7 0 0 1 .7-.7h9.726a.7.7 0 0 1 .7.7V16.3a.7.7 0 0 1-.7.7H3.7a.7.7 0 0 1-.7-.7V6.574Zm1.4.7V15.6h8.326V7.274H4.4Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M4.99 3.7a.7.7 0 0 1 .7-.7H16.3a.7.7 0 0 1 .7.7v10.61a.7.7 0 0 1-.7.7h-2.517a.7.7 0 1 1 0-1.4H15.6V4.4H6.39v1.51a.7.7 0 1 1-1.4 0V3.7Z"
            clipRule="evenodd"
        />
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M12.96 13.616c-3.312-1.242-6.888-.43-8.553.388a.7.7 0 1 1-.618-1.257c1.916-.941 5.9-1.853 9.662-.442a.7.7 0 0 1-.492 1.31Z"
            clipRule="evenodd"
        />
        <path fill="currentColor" d="M7.332 9.534a.777.777 0 1 1-1.554 0 .777.777 0 0 1 1.554 0Z" />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
